import { Navigate } from "react-router-dom";

const RoleRedirect = () => {
  const role = localStorage.getItem("adminRole");

  if (role === "customer") {
    return <Navigate to="/homeloanlist" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default RoleRedirect;
